
//######################################################################
//######################################################################
//######################################################################
//defaults


//=====================================================
//=====================================================

//-------------------------
//fields
//-------------------------

//var def_name = '';
var def_email = '';
var def_pword = '';
// var def_company = '';	
// var def_phone = '';
// var def_message = '';
// var def_band = '';



var use_defaults = true;


//=====================================================
//=====================================================

if(use_defaults)
{


    //-------------------------
    //fields
    //-------------------------

    //def_name = 'Tom M';
    //def_email = 'tpc@theprofitcalculator.com';
    //def_pword = 'MixelPlix_2021';
    // def_company = '';
    // def_phone = "555-444-3333";
    // def_message = 'This is a test message';
    // def_band = '';


    //-------------------------
    //captcha
    //-------------------------

    //def_captcha = "1234";//dynamically retrieved




}//==










const Composer = [


    {

        "call":"header",
        "data":{

            "text":"Sign Up"
        }

    },






    //##########################################################################
    //##########################################################################
    //##########################################################################
    //customer info


    //==========================================
    //bar
    //==========================================
    {

        "call"   :"bar",
        "data"      :{

            "text"  :"Login Info."

        }


    },
    
    
    //==========================================
    //fields
    //==========================================
    {

        "call"   :"fields",
        "data"      :[




            // //--------------------------------
            // //
            // //--------------------------------
            // {


            //     "fieldtype"               	:"text",
            //     "required"					:true,

            //     "class"                   	:'',
            //     "id"                      	:'name',
            //     "hint"                    	:"Name",

            //     "text"                     	:def_name,



            //     "keyboardType"            	:"",
            //     "autocorrect"             	:"false",
            //     "autocapitalizationType"  	:"none",


            //     //"secure"                  :true,
            //     //"returnKeyType"           :"done"


            // },




            //--------------------------------
            //
            //--------------------------------
            {


                "fieldtype"               	:"text",
                "required"					:true,

                "class"                   	:'',
                "id"                      	:'email',
                "hint"                    	:"Email",

                "text"                     	:def_email,



                "keyboardType"            	:"email",
                "autocorrect"             	:"false",
                "autocapitalizationType"  	:"none",


                //"secure"                  :true,
                //"returnKeyType"           :"done"


            },





            // //--------------------------------
            // //
            // //--------------------------------
            // {


            //     "fieldtype"               	:"text",
            //     "required"					:false,

            //     "class"                   	:'',
            //     "id"                      	:'company',
            //     "hint"                    	:"Company ( Optional )",

            //     "text"                     	:"",



            //     "keyboardType"            	:"",
            //     "autocorrect"             	:"false",
            //     "autocapitalizationType"  	:"none",


            //     //"secure"                  :true,
            //     //"returnKeyType"           :"done"


            // },




            
        
            
            //--------------------------------
            //password
            //--------------------------------
            {


                "fieldtype"               	:"password",
                "required"					:true,

                "class"                   	:'',
                "id"                      	:'pword',
                "hint"                    	:"Password",

                "text"                     	:def_pword,



                "keyboardType"            	:"",
                "autocorrect"             	:"false",
                "autocapitalizationType"  	:"none",


                //"secure"                  :true,
                //"returnKeyType"           :"done"


            },
            




            // //--------------------------------
            // //
            // //--------------------------------

            // {


            //     "fieldtype"               	:"select",
            //     "required"					:true,

            //     "class"                   	:'',
            //     "id"                      	:'band',
            //     "hint"                    	:"Choose Band",

            //     "text"                     	:[],
            //     "array"                     :[

            //         "Van Halen",
            //         "AC/DC",
            //         "Led Zeppelin",
            //         "Aerosmith",
            //         "Black Sabbath",
            //         "Judas Priest"
                
            //     ],

            //     "keyboardType"            	:"",
            //     "autocorrect"             	:"false",
            //     "autocapitalizationType"  	:"none",


            //     //"secure"                  :true,
            //     //"returnKeyType"           :"done"


            // },
    





            


            // //--------------------------------
            // //
            // //--------------------------------
            // {


            //     "fieldtype"               	:"phone",
            //     "required"					:false,

            //     "class"                   	:'',
            //     "id"                      	:'phone',
            //     "hint"                    	:"Phone",

            //     "text"                     	:"",
            

            //     "keyboardType"            	:"",
            //     "autocorrect"             	:"false",
            //     "autocapitalizationType"  	:"none",


            //     //"secure"                  :true,
            //     //"returnKeyType"           :"done"


            // }


        ]

        

    },



    // {
    //     "call"   :"spacer",
    //     "data"      :{

    //         "name"		:'info-end',
    //         "color"   	:'transparent',
    //         "height"  	:50

    //     }

    // },












    



    // //##########################################################################
    // //##########################################################################
    // //##########################################################################
    // //questionnaire



    // //==========================================
    // //bar
    // //==========================================
    // {

    //     "call"   :"bar",
    //     "data"      :{

    //         "text"  :"Info."

    //     }


    // },
    






    // //==========================================
    // //headline
    // //==========================================
    // {

    //     "call"   :"headline",
    //     "data"      :{

    //         "text"  :'How did you hear about Power Digital Media'

    //     }


    // },

    // //==========================================
    // //radiobuttons
    // //==========================================
    // {

    //     "call"   :"radiobuttons",
    //     "data"      :{
            
    //         "call"      :'rad',
    //         "required"	:true,
    //         "name"      :'hearabout',
    //         "array"     :[
    
    //             "Job Post",
    //             "Internet Search",
    //             "Linked In",
    //             "Other"
    //         ],
    //         "choice"    :["Internet Search"]

    //     }


    // },




    // //==========================================
    // //headline
    // //==========================================
    // {

    //     "call"   :"headline",
    //     "data"      :{

    //         "text"  :'What type of work do you need completed?'

    //     }


    // },

    // //==========================================
    // //checkboxes
    // //==========================================
    // {

    //     "call"   :"radiobuttons",
    //     "data"      :{
            
    //         "call"      :'rad',
    //         "required"	:true,
    //         "name"      :'typeofwork',
    //         "array"     :[

    //             "Consulting",
            
    //             "Full Stack",
    //             "Frontend ",
    //             "Backend",
            
    //             "Not Sure"
            
    //         ],
    //         "choice"    :['Full Stack']

    //     }


    // },



    

    // //==========================================
    // //headline
    // //==========================================
    // {

    //     "call"   :"headline",
    //     "data"      :{

    //         "text"  :'What skills or technologies you are looking for? Check all that apply.'

    //     }


    // },


    // //==========================================
    // //checkboxes
    // //==========================================
    // {

    //     "call"   :"checkboxes",
    //     "data"      :{
            
    //         "call"      :'chk',
    //         "required"	:false,
    //         "name"      :'skills',
    //         "array"     :[

    //             "Javascript",
    //             "Node.js",
    //             "Php",
    //             "Python",
    //             "AWS"
            
    //         ],
    //         "choice"    :["Node.js","Aws"]

    //     }


    // },


    







    // //##########################################################################
    // //##########################################################################
    // //##########################################################################
    // //message


    // //==========================================
    // //headline
    // //==========================================
    // {

    //     "call"   :"headline",
    //     "data"      :{

    //         "text"  :'Message'

    //     }


    // },

    // //==========================================
    // //fields
    // //==========================================
    // {

    //     "call"   :"fields",
    //     "data"      :[



    //         //--------------------------------
    //         //
    //         //--------------------------------
    //         {


    //             "fieldtype"               	:"textarea",
    //             "required"					:true,

    //             "class"                   	:'',
    //             "id"                      	:'message',
    //             "hint"                    	:"Message",

    //             "text"                     	:def_message,



    //             "keyboardType"            	:"",
    //             "autocorrect"             	:"false",
    //             "autocapitalizationType"  	:"none",


    //             //"secure"                  :true,
    //             //"returnKeyType"           :"done"


    //         }



    //     ]

        

    // },


    // {
    //     "call"   :"spacer",
    //     "data"      :{

    //         "name"		:"after-message",
    //         "color"   	:'transparent',
    //         "height"  	:25

    //     }

    // },













    //##########################################################################
    //##########################################################################
    //##########################################################################
    //captcha


    // //==========================================
    // //headline
    // //==========================================
    // {

    //     "call"   :"headline",
    //     "data"      :{

    //         "text"  :'Enter Confirmation Code'

    //     }


    // },


    // //==========================================
    // //captcha
    // //==========================================

    // {
    //     "call"   :"captcha",
    //     "data"      :{

    //         "required"	:required_captcha,
    //         "capnum"	:def_captcha

    //     }


    // },






    // {
    //     "call"   :"spacer",
    //     "data"      :{

    //         "name"		:"before-button",
    //         "color"   	:'transparent',
    //         "height"  	:50

    //     }

    // },


    




    //##########################################################################
    //##########################################################################
    //##########################################################################
    //button


    {
        "call"   :"spacer",
        "data"      :{

            "name"		:'button-begin',
            "color"   	:'transparent',
            "height"  	:30

        }

    },



    {
        "call"   :"button",
        "data"      :{

            "text"  :'Submit',
            "class" :'btn-submit',
            "funct"	:{

                "name":"FormSubmit",
                "object":false

            },
            "action":'submit'
            
        }

    },




    

    //##########################################################################
    //##########################################################################
    //##########################################################################
    //link

    {
        "call"   :"spacer",
        "data"      :{

            "name"		:'before-link',
            "color"   	:'transparent',
            "height"  	:20

        }

    },

    {
        "call"   :"link",
        "data"      :{

            "text"  :'Do you have an account? "Login"',
            "class" :'btn-link',
            "funct"	:{

                "name":"handleUrl",
                "object":{

                    "url":"/Login/"

                }

            },
            "action":'url',
            "url":"/Login/"
            
        }

    },

    

    
    {
        "call"   :"spacer",
        "data"      :{

            "name"		:"bottom",
            "color"   	:'transparent',
            "height"  	:10

        }

    }




]


export default Composer;
